const api = {
    getNodeInfo: 'node/detail', //获取区块信息
    getNoticeList: 'notice/query', //获取公告列表
    getNoticeDetail: 'notice/get', //获取公告/周报详情
    getReportList: 'news/query', //获取媒体报道列表
    getReportDetail: 'news/get', //获取媒体报道详情
    getWeeklyList: 'report/query', //获取周报列表
    // getWeeklyDetail: 'report/get', //获取周报详情
    getJoinInfo: 'recruit/query', //获取招聘信息

    getCountryList: 'country/select', //获取国家列表
    sendSms: 'sms/send', //发送验证码
    applyDeveloper: 'kyc/add', //开发者申请
}

export default api